import anime from 'animejs';
import store from './util/store';
import DomCreator from './util/DomCreator';

export function rand(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
export function randFloat(min, max) {
  return Math.random() * (max - min) + min;
}

export function shuffle(a) {
  for (let i = a.length; i; i--) {
    let j = Math.floor(Math.random() * i);
    [a[i - 1], a[j]] = [a[j], a[i - 1]];
  }
}

export function konami(callback) {
  var k = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65],
    n = 0;
  document.addEventListener('keydown', function (e) {
    if (e.keyCode === k[n++]) {
      if (n === k.length) {
        callback();
        n = 0;
        return false;
      }
    } else {
      n = 0;
    }
  });
}

export function getHeaderHeight() {
  let logo = document.querySelector('.js-logo');
  return logo.offsetHeight + logo.offsetTop * 2;
}

export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
  );
}

export function scrollTo({ to, duration, delay, $container }) {
  let from = { top: store.scrollTop };
  duration = duration || 1000;
  delay = delay || 0;

  if ($container) {
    from.top = $container.scrollTop;
  }

  to += from.top;
  anime({
    targets: from,
    top: to,
    duration: duration,
    easing: 'easeInOutExpo',
    delay: delay,
    update: () => {
      if ($container) {
        $container.scrollTop = from.top;
      } else {
        document.querySelector('.main').scrollTop = from.top;
      }
    },
  });
}

export function getTop(el) {
  const bodyRect = document.body.getBoundingClientRect(),
    elemRect = el.getBoundingClientRect(),
    top = elemRect.top - bodyRect.top;

  return top;
}

export function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

export function lerp(v0, v1, t) {
  return (1 - t) * v0 + t * v1;
}

export function copyOnClick($el, string) {
  const hoverMessage = document.createElement('span');
  const successMessage = document.createElement('span');

  hoverMessage.innerHTML = $el.getAttribute('data-hover')
    ? $el.getAttribute('data-hover')
    : window.translations.copy;
  successMessage.innerHTML = $el.getAttribute('data-success')
    ? $el.getAttribute('data-success')
    : window.translations.copy_success;

  const messageContainer = document.createElement('div');
  messageContainer.append(hoverMessage);
  messageContainer.append(successMessage);
  $el.append(messageContainer);

  $el.addEventListener('click', (e) => {
    e.preventDefault();

    var copy = string.replace('mailto:', '');
    copyToClipboard(copy);
    $el.classList.add('copy-success');
    setTimeout(() => $el.classList.remove('copy-success'), 3000);

    if (window.innerWidth < 769 || $el.classList.contains('js-feedback-alert')) {
      const alert = DomCreator.alert(successMessage.innerHTML);
      document.body.appendChild(alert);
      DomCreator.removeAfter(alert, 2);
    }
  });
}

/**
 * Copy a string to clipboard
 * @param  {String} string         The string to be copied to clipboard
 * @return {Boolean}               returns a boolean correspondent to the success of the copy operation.
 */
export function copyToClipboard(string) {
  let textarea;
  let result;

  try {
    textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', true);
    textarea.setAttribute('contenteditable', true);
    textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
    textarea.value = string;

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    textarea.setSelectionRange(0, textarea.value.length);
    result = document.execCommand('copy');
  } catch (err) {
    console.error(err);
    result = null;
  } finally {
    document.body.removeChild(textarea);
  }

  // manual copy fallback using prompt
  if (!result) {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
    result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
    if (!result) {
      return false;
    }
  }
  return true;
}

export function animationOnIntersection($element, animation) {
  if (isFunction(IntersectionObserver)) {
    let observer = new IntersectionObserver((intersections) => {
      const inter = intersections[0];
      if (inter.isIntersecting && !animation.completed) {
        animation.play();
      }
    });
    observer.observe($element);
  } else {
    animation.play();
  }
}

export function collides(obj1, obj2) {
  return (
    obj1.x < obj2.x + obj2.width &&
    obj1.x + obj1.width > obj2.x &&
    obj1.y < obj2.y + obj2.height &&
    obj1.y + obj1.height > obj2.y
  );
}



// WEBPACK FOOTER //
// ./scripts/functions.js